import { Panel, Typography } from "@/components/atoms";
import { useOperator } from "@/hooks";
import { useGetProviderBillingHistoryQuery } from "@/redux/apis/subscription/subscriptionPlansApi";
import { SubscriptionBillingHistoryTable } from "./SubscriptionBillingHistory/SubscriptionBillingHistoryTable";

export const SubscriptionBillingHistory = () => {
  const operator = useOperator();
  const {
    data: billingHistory,
    isLoading,
    error,
  } = useGetProviderBillingHistoryQuery({
    providerId: operator.id,
    limit: 10,
  });

  if (error) {
    return (
      <Panel className="flex flex-col gap-4">
        <Typography variant="h2">Subscription Billing History</Typography>
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          Unable to load billing history
        </Typography>
      </Panel>
    );
  }

  return (
    <Panel className="flex flex-col gap-4">
      <Typography variant="h2">Subscription Billing History</Typography>
      <SubscriptionBillingHistoryTable items={billingHistory || []} isLoading={isLoading} />
    </Panel>
  );
};
